import { useContext } from 'react'

import { DebtsPartnersContext } from '@/legacy/providers/DebtsPartnersProvider'

export const usePartner = ({ path }: { path: string | undefined }) => {
  const { list } = useContext(DebtsPartnersContext)

  if (!list.length) {
    return null
  }

  if (!path) {
    return null
  }

  return list.find((partner) => partner.link && partner.link.endsWith(path))
}
